import styles from "./productsSwiper.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css/pagination";
import "swiper/css";
import "swiper/css/navigation";
import { useState } from "react";
import { useEffect } from "react";
import { Products } from "@/lib/products";
import { svgImages } from "@/lib/svgImages";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import Link from "next/link";

function ProductsSwiper({ data, isDynamic }) {
  const [loading, setLoading] = useState(true);
  const [allList, setAllList] = useState([]);
  const [staticList, setStaticList] = useState([]);
  var staticListArr = [];
  const { t } = useTranslation();
  useEffect(() => {
    for (let index = 0; index < Products.productsTabsSection.length; index++) {
      const element = Products.productsTabsSection[index];
      if (!element.isDynamic) {
        staticListArr.push(element);
        setStaticList(staticListArr);
      }
    }
  }, []);

  useEffect(() => {
    (async () => {
      var allListArr = [];

      const data = await fetch(
        "https://cms.qrhub.io/wp-json/wp/v2/products?per_page=100",
        { cache: "force-cache" }
      ).then((res) => res.json());

      if (data != undefined) {
        for (let index = 0; index < data.length; index++) {
          const element = data[index];

          if (element?.acf.isdynamic == true) {
            allListArr.push(element);
            setAllList(allListArr);
          } else {
            staticListArr.push(element);
            setStaticList(staticListArr);
          }
        }
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className={`${styles["productsSwiper"]}`}>
      <div className={styles.sliderContainer}>
        <Swiper
          modules={[Navigation, Autoplay, Pagination]}
          centeredSlides={false}
          loop={false}
          navigation={{
            nextEl: `.${styles.swiperButtonNext}`,
            prevEl: `.${styles.swiperButtonPrev}`,
          }}
          // autoplay={{
          //   delay: 3000,
          //   disableOnInteraction: false,
          //   pauseOnMouseEnter: true,
          // }}
          pagination={{
            el: `.${styles.swiperPagination}`,
            clickable: true,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1.1,
              spaceBetween: 10,
              autoplay: {
                disableOnInteraction: true,
              },
            },

            480: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1025: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          }}
          className={styles.featuresSwiperElement}
          initialSlide={0}
          grabCursor={true}
        >
          {isDynamic
            ? data &&
              data
                .sort((a, b) => (a.id < b.id ? -1 : 1))
                .map((slide) => (
                  <SwiperSlide key={slide.id} className={styles.swiperSlide}>
                    <Link
                      href={`/en/products/${slide.slug}/`}
                      className={styles.card}
                    >
                      <div className={styles.cardImage}>
                        <Image
                          src={`/images/products/${slide.slug}.webp`}
                          alt={slide.title.rendered}
                          width={300}
                          height={400}
                        />
                      </div>
                      <div className={styles.footer}>
                        <div className={styles.titleSection}>
                          <div className={`${styles.cardIcon} activeIcon`}>
                            <span
                              dangerouslySetInnerHTML={{
                                __html:
                                  svgImages[slide.slug.replace(/-/g, "_")],
                              }}
                            />
                          </div>
                          <div
                            className={`${styles.cardTitle} line-height-title`}
                            dangerouslySetInnerHTML={{
                              __html: slide.title.rendered,
                            }}
                          />
                        </div>

                        <span
                          className={styles.arrow}
                          dangerouslySetInnerHTML={{
                            __html: svgImages.navRight,
                          }}
                        />
                      </div>
                    </Link>
                  </SwiperSlide>
                ))
            : data &&
              data.map((slide) => (
                <SwiperSlide key={slide.id} className={styles.swiperSlide}>
                  <Link href={`/en/static-products`} className={styles.card}>
                    <div className={styles.cardImage}>
                      <Image
                        src={slide.image}
                        alt={t(slide.title)}
                        width={400}
                        height={400}
                      />
                    </div>
                    <div className={styles.footer}>
                      <div className={styles.titleSection}>
                        <div className={`${styles.cardIcon} activeIcon`}>
                          <span
                            dangerouslySetInnerHTML={{
                              __html:
                                svgImages[
                                  `qr_${t(slide.title)
                                    .toLowerCase()
                                    .replace(/[\s-]/g, "_")}`
                                ],
                            }}
                          />
                        </div>
                        <div
                          className={`${styles.cardTitle} line-height-title`}
                          dangerouslySetInnerHTML={{
                            __html: t(slide.title),
                          }}
                        />
                      </div>

                      <span
                        className={styles.arrow}
                        dangerouslySetInnerHTML={{
                          __html: svgImages.navRight,
                        }}
                      />
                    </div>
                  </Link>
                </SwiperSlide>
              ))}
        </Swiper>

        <div className={`${styles.swiperPagination} darkBullets`}></div>
      </div>
    </div>
  );
}
export default ProductsSwiper;
